import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../shared";
import { ROUTES } from "./change-password.routes";
import { ChangePasswordService } from "./change-password.service";
import { ChangePasswordFormComponent } from "./change-password-form.component";

const components = [ChangePasswordFormComponent];

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		SharedModule,
		RouterModule.forChild(ROUTES),
		RouterModule,
	],
	declarations: [...components],
	exports: [...components],
	providers: [ChangePasswordService],
})
export class ChangePasswordModule {}
